import { render } from "./CountDown.vue?vue&type=template&id=70e5467b&ts=true"
import script from "./CountDown.vue?vue&type=script&lang=ts"
export * from "./CountDown.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__